// Dados mockados para simulação
const MOCK_CAMPAIGNS = [
    { id: 1, name: 'Black Friday 2025', discountPercentage: 10, bonus: 'Semana bônus', validUntil: '2025-11-30', applicationScope: 'all' },
    { id: 2, name: 'Primavera Especial', discountPercentage: 5, bonus: null, validUntil: '2025-12-21', applicationScope: 'torre-sul' },
    { id: 3, name: 'Lançamento Torre Leste', discountPercentage: 15, bonus: 'Mobília incluída', validUntil: '2025-09-30', applicationScope: 'torre-leste' }
];

const MOCK_APPOINTMENTS = [
    { id: 1, clientName: 'João Silva', type: 'Visita ao Empreendimento', time: '09:30', date: '2025-04-29', status: 'scheduled' },
    { id: 2, clientName: 'Maria Oliveira', type: 'Assinatura de Contrato', time: '11:00', date: '2025-04-29', status: 'confirmed' },
    { id: 3, clientName: 'Roberto Mendes', type: 'Reunião com Investidor', time: '15:30', date: '2025-04-29', status: 'pending' }
];

const MOCK_SALES = [
    { id: 1, clientName: 'João Carlos Silva', unit: 'Torre Sul 1004 - Sem. 14', value: 58500, date: '2025-04-22', status: 'signed' },
    { id: 2, clientName: 'Maria Oliveira Santos', unit: 'Torre Norte 505 - Completo', value: 780000, date: '2025-04-20', status: 'pending' },
    { id: 3, clientName: 'Carlos Eduardo Martins', unit: 'Torre Sul 1002 - Sem. 22', value: 62000, date: '2025-04-18', status: 'signed' },
    { id: 4, clientName: 'Ana Beatriz Gomes', unit: 'Torre Norte 302 - Sem. 15', value: 55000, date: '2025-04-15', status: 'pending' }
];

const MOCK_PERFORMANCE = {
    salesCount: 48,
    salesChange: 12,
    salesPercentage: 75,
    totalRevenue: 3200000,
    revenueChange: 8,
    revenuePercentage: 66,
    conversionRate: 32,
    conversionChange: -3,
    conversionPercentage: 33
};

/**
 * Obtém a lista de campanhas promocionais ativas
 * @returns {Promise<Array>} Lista de campanhas
 */
export const getCampaigns = async() => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));
    return MOCK_CAMPAIGNS;
};

/**
 * Obtém os compromissos agendados para hoje
 * @returns {Promise<Array>} Lista de compromissos
 */
export const getTodayAppointments = async() => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));
    return MOCK_APPOINTMENTS;
};

/**
 * Obtém as vendas mais recentes
 * @param {number} limit - Quantidade máxima de vendas a retornar
 * @returns {Promise<Array>} Lista de vendas recentes
 */
export const getRecentSales = async(limit = 10) => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));
    return MOCK_SALES.slice(0, limit);
};

/**
 * Obtém os dados de performance de vendas
 * @param {string} period - Período de análise (7days, 30days, 90days, year)
 * @returns {Promise<Object>} Dados de performance
 */
export const getSalesPerformance = async(period = '30days') => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));
    return MOCK_PERFORMANCE;
};

/**
 * Obtém todos os dados relacionados a vendas
 * @returns {Promise<Object>} Dados de vendas
 */
export const getSalesData = async() => {
    // Simulação de atraso de rede
    await new Promise(resolve => setTimeout(resolve, 300));
    return {
        recentSales: MOCK_SALES,
        performance: MOCK_PERFORMANCE
    };
};